import React from "react";
import { Box, Typography, Paper, Stack } from "@mui/material";
import { styled } from "@mui/material/styles";
import { ActionDropdownButton } from "./ActionDropdownButton";
import { RiveByKey } from "../../riveAnimation";

interface Action {
  label: string;
  icon: React.ReactNode;
  onClick: () => void;
}

interface EmptyStateProps {
  title: string;
  description: string;
  actionLabel?: string;
  actions?: Action[];
  actionComponent?: React.ReactNode;
}

const MinimalCard = styled(Paper)(({ theme }) => ({
  backgroundColor: "var(--fx-surface-base, #FFFFFF)",
  borderRadius: "24px",
  padding: theme.spacing(4, 3),
  textAlign: "center",
  maxWidth: "calc(100% - 32px)",
  width: "100%",
  boxSizing: "border-box",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  position: "relative",
  boxShadow: "none",
  border: "1px solid rgba(255, 152, 0, 0.15)",
}));

export const CardNoJob: React.FC<EmptyStateProps> = ({ title, description, actionLabel, actions, actionComponent }) => {
  return (
    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", flexGrow: 1, p: 2 }}>
      <MinimalCard elevation={0}>
        <Box
          sx={{
            height: 150,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            overflow: "visible",
            mb: 1,
          }}
        >
          <RiveByKey riveKey="timesheets" boxSize={180} />
        </Box>

        <Stack spacing={1} sx={{ mb: 3, maxWidth: "300px" }}>
          <Typography variant="h5" sx={{ fontWeight: 800, color: "var(--fx-surface-text, #0F172A)", fontSize: "1.4rem", letterSpacing: "-0.01em" }}>
            {title}
          </Typography>
          <Typography variant="body2" sx={{ color: "var(--fx-surface-textsecondary, #64748B)", fontSize: "0.875rem", lineHeight: 1.4 }}>
            {description}
          </Typography>
        </Stack>

        {actionComponent ? actionComponent : <ActionDropdownButton actionLabel={actionLabel!} actions={actions!} />}
      </MinimalCard>
    </Box>
  );
};
